import { RxState } from '@rx-angular/state';
import { TranslateModule } from '@ngx-translate/core';
import { AVATAR_WIDTH } from '../../../constants';
import { TranslationModule } from '../../../i18n/translation-module';
import { CollapsibleSectionComponent } from '../../collapsible-section/collapsible-section.component';
import { ActivityInterface } from '@vendasta/crm';
import { CommonModule } from '@angular/common';
import { Component, computed, Input, WritableSignal, signal, Signal } from '@angular/core';
import { CrmFieldService, StandardIds, SystemFieldIds } from '../../../shared-services/crm-services/field.service';
import { MatCardModule } from '@angular/material/card';
import { DateFormat } from '@vendasta/galaxy/utility/date-utils';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { CrmUnknownUserAvatarComponent } from '../../unknown-user-avatar/unknown-user-avatar.component';

@Component({
  selector: 'crm-activity-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss'],
  providers: [RxState],
  imports: [
    CommonModule,
    TranslateModule,
    TranslationModule,
    CollapsibleSectionComponent,
    MatCardModule,
    GalaxyAvatarModule,
    CrmUnknownUserAvatarComponent,
  ],
  standalone: true,
})
export class CrmActivityNoteComponent {
  private _activity: WritableSignal<ActivityInterface> = signal({});
  @Input({ required: true }) set activity(activity: ActivityInterface) {
    this._activity.set(activity);
  }
  get activity() {
    return this._activity();
  }

  private _showAvatar = true;
  @Input() set showAvatar(showAvatar: boolean) {
    this._showAvatar = showAvatar;
  }

  get showAvatar() {
    return this._showAvatar;
  }
  dateFormat = DateFormat.medium;

  cardInfo: Signal<ActivityCardInformation> = computed(() => {
    return {
      noteBody: this.getStringFieldData(this.activity, StandardIds.ActivityNoteBody),
      noteTitle: this.getStringFieldData(this.activity, StandardIds.ActivityNoteTitle),
      sourceName: this.getStringFieldData(this.activity, StandardIds.ActivitySourceName),
      effectiveDate: this.getDateFieldData(this.activity, SystemFieldIds.ActivityEffectiveDate),
    };
  });

  private getStringFieldData(activity: ActivityInterface, fieldId: string): string {
    return this.fieldService.getFieldValueFromCrmObject(activity, fieldId)?.stringValue ?? '';
  }

  private getDateFieldData(activity: ActivityInterface, fieldId: string): Date | null {
    return this.fieldService.getFieldValueFromCrmObject(activity, fieldId)?.dateValue ?? null;
  }

  constructor(private readonly fieldService: CrmFieldService) {}

  protected readonly AVATAR_WIDTH = AVATAR_WIDTH;

  headerText = computed(() => {
    const { noteTitle, sourceName } = this.cardInfo();

    if (sourceName) {
      return `${noteTitle} in ${sourceName}`.trim();
    }
    return noteTitle ?? '';
  });
}

interface ActivityCardInformation {
  sourceName: string;
  noteBody: string;
  noteTitle: string;
  effectiveDate: Date | null;
}
